import { ReactElement } from 'react';
import { Layout } from '../../../components/layout/Layout';
import Header from '../../../components/header/Header';
import type { Honbu } from '../types';
import Content from './Content';

interface Props {
  honbu: Honbu;
}

const SettingPage = ({ honbu }: Props): ReactElement => {
  return <Layout header={<Header />} content={<Content honbu={honbu} />} />;
};

export default SettingPage;
